import React from 'react';
import { useDispatch } from 'react-redux';
import { setLoginMode } from '../../../Actions/Login.action';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';
import { translate } from '../../../Services/translation';
import LoginMode from '../../../Types/LoginMode';
import Input from '../../Inputs/Input';
import clsx from 'clsx';
import EditorString from '../../EditorString/EditorString';

const LoginForm = () => {
  const { isLoading, createAccountMessage } = useTypedSelector(
    (state) => state.login
  );
  const dispatch = useDispatch();

  return (
    <>
      <div className="mb-6 flex flex-col gap-2">
        <h3 className="uppercase">{translate('login.create-account')}</h3>
        {createAccountMessage?.value && (
          <EditorString
            value={createAccountMessage?.value}
            className="text-lg"
          />
        )}
      </div>
      <form>
        <Input
          label={translate('general.placeholder.name')}
          inputSize="large"
          wrapperClassName={clsx('mb-4')}
          placeholder={translate('general.name')}
          disabled={isLoading}
        />
        <Input
          label={translate('general.placeholder.email')}
          inputSize="large"
          wrapperClassName={clsx('mb-4')}
          placeholder={translate('general.email')}
          disabled={isLoading}
        />
        <Input
          label={translate('general.password')}
          inputSize="large"
          placeholder={translate('general.placeholder.password')}
          disabled={isLoading}
          type="password"
        />
        <button
          type="submit"
          className={clsx(
            'mt-6',
            'btn',
            'btn--large',
            'w-full',
            'btn--secondary',
            'lg:mt-8'
          )}
          disabled={isLoading}
        >
          {!isLoading && translate('login.register')}
          {isLoading && translate('general.loading')}
        </button>
      </form>
      <button
        className={clsx(
          'btn',
          'btn--clear',
          'btn--medium',
          'underline',
          'w-full',
          'normal-case',
          'text-md',
          'font-normal',
          'mt-4',
          'lg:mt-6'
        )}
        onClick={() => dispatch(setLoginMode(LoginMode.Login))}
        disabled={isLoading}
      >
        {!isLoading && translate('general.back')}
        {isLoading && translate('general.loading')}
      </button>
    </>
  );
};

export default LoginForm;
